import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import classNames from "classnames";
import { handlePostRequest } from "../../../services/PostTemplate";
import { handlePutRequest } from "../../../services/PutTemplate";
import { Button } from "primereact/button";
import * as Yup from "yup";
import { InputText } from "primereact/inputtext";
import { v4 as uuidv4 } from 'uuid';

const AddEditRole = ({ onHide, editable, roleRowData, getRoles }) => {
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("pi pi-save");
    const roleId = roleRowData?.roleId;

    useEffect(() => {
        if (roleRowData !== null) {
            formik.setFieldValue("roleName", roleRowData.roleName);
            // formik.setFieldValue("roleCode", roleRowData.roleCode);
        }
    }, [roleRowData]); // eslint-disable-line

    const validationSchema = Yup.object().shape({
        roleName: Yup.string().required("This field is required."),
        // roleCode: Yup.string().required("This field is required."),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            roleName: "",
            // roleCode: "",
        },
        onSubmit: async (data) => {
            const uuId = uuidv4();
            const uniqueId = uuId.split("-");
            setloading(true);
            setloadingIcon("pi pi-spin pi-spinner");
            data["roleId"] = roleId;

            try {
                if (editable === true) {
                    await handlePutRequest(data, `zbizgateway/nonFin/updateRole`);
                } else {
                    data["roleCode"] = formik.values.roleName + "_" + uniqueId[4];
                    await handlePostRequest(data, "zbizgateway/nonFin/saveRole");
                }
                await getRoles();
                onHide();
            } catch (error) {
                console.error("An error occurred:", error);
            } finally {
                setloading(false);
                setloadingIcon("pi pi-save");
                formik.resetForm();
            }
        },

    });
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <>
            <div className="card Card__Round">
                <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                    <div className="p-field p-col-12 p-md-12">
                        <div className="p-field input_cp">
                            <label htmlFor="roleName" className={classNames({ "p-error": isFormFieldValid("roleName") }, "Label__Text")}>
                                Name<span className="Label__Required">*</span>
                            </label>
                            <InputText placeholder="Enter Name of Role" id="roleName" name="roleName" value={formik.values.roleName} rows={5} cols={10} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("roleName") }, "input_text")} />
                            {getFormErrorMessage("roleName")}
                        </div>
                    </div>
                    {/* <div className="p-field p-col-12 p-md-12">
                        <div className="p-field">
                            <label htmlFor="roleCode" className={classNames({ "p-error": isFormFieldValid("roleCode") }, "Label__Text")}>
                                Role Code<span className="Label__Required">*</span>
                            </label>
                            <InputText placeholder="Enter Code for Role" id="roleCode" name="roleCode" value={formik?.values?.roleCode?.replace(/\s\s+/g, " ")} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("roleCode") }, "Input__Round")} />

                            {getFormErrorMessage("roleCode")}
                        </div>
                    </div> */}
                    <div className="Top__Btn">
                        <Button disabled={loading} label={editable ? "Update" : "Add"} className="Add_New" />
                    </div>
                </form>
            </div>
        </>
    );
};

export default AddEditRole;
